import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getTeamsKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
const BASE_URL = 'app-users/v1/teams';
export const _fetchTeams = () => http.get(`${BASE_URL}`);
export const getTeams = () => getFromEarlyRequest(getTeamsKey(), () => _fetchTeams());